export function setToken(token: string) {
  localStorage.setItem("token", token);
}

export function unsetToken() {
  localStorage.removeItem("token");
}

export function getToken() {
  return localStorage.getItem("token");
}
